import React from 'react';

export default function FloatingChatButton() {
  return (
    <a
      href="mailto:support@example.com"
      className="fixed bottom-5 right-4 z-[60] flex items-center gap-2 rounded-full bg-[#5c2d91] px-4 py-3 text-sm font-semibold text-white shadow-xl ring-2 ring-white/30 transition hover:bg-[#4a2475] hover:shadow-2xl safe-area-bottom sm:bottom-6 sm:right-6"
      style={{ marginBottom: 'max(0.5rem, env(safe-area-inset-bottom))' }}
    >
      <span className="text-lg" aria-hidden>
        💬
      </span>
      Chat with us
    </a>
  );
}
